import React from 'react';
import { IconPopup, List, PriceInformation, Typography, HintMessage } from '@adac-mp/components';
import { IListItemProps, IPricingElements, ITotalPrice } from '@adac-mp/shared';

interface IRenderTotalPrice {
	addendum?: boolean;
	paymentHint?: boolean;
	hasMembership?: boolean;
	hasMembershipBenefit?: boolean;
	isDkvPage?: boolean;
	price: ITotalPrice;
	pricingElements: IPricingElements;
	showSubHeadline?: boolean;
}

export const renderTotalPrice = ({
	addendum = false,
	hasMembership = false,
	hasMembershipBenefit = false,
	price,
	pricingElements,
	showSubHeadline = false,
	paymentHint = false,
}: IRenderTotalPrice) => {
	const renderList = (list: IListItemProps[][], headline?: string) => (
		<>
			{showSubHeadline && headline && (
				<Typography component="p" color="title" className="px-4 mb-1.5">
					{headline}
				</Typography>
			)}
			{list.map((listItems, id) => (
				<List
					key={id}
					labelVariant={addendum ? 'title' : 'abstract'}
					items={listItems.map((listItem) => ({
						...listItem,
						labelVariant: listItem.isProductPrice ? 'title' : 'abstract',
					}))}
				/>
			))}
		</>
	);

	return {
		...price,
		label: (
			<>
				<span className="inline-block">
					{String(price.label).replace('*', '')}
					<IconPopup
						bold
						type="info"
						buttonStyle="align-middle ml-1"
						title={pricingElements.label}
						iconTitle="Übersicht Preisbestandteile"
						paddingX="small"
						content={{
							content: (
								<>
									{pricingElements.additionalInfo.map((element, index) => (
										<div
											key={index}
											className={`flex flex-col gap-1.5 mb-4 ${index > 0 ? '' : 'pt-4'}`}>
											{element.details && renderList(element.details, element.title)}
										</div>
									))}
									<PriceInformation
										showDiscount
										className="px-4"
										labelSize="xl"
										totalPrice={price}
										hasMembership={hasMembership}
										hasMembershipBenefit={hasMembershipBenefit}
									/>
									{addendum && (
										<Typography color="lightText" size="sm" className="px-4 mt-4">
											*Sie erhalten die bereits bezahlten, noch verbleibenden Restmonate aus dem
											Altvertrag im Neuvertrag gutgeschrieben.
										</Typography>
									)}
									{paymentHint && (
										<HintMessage
											className="mt-4"
											hints={[
												{
													tip: 'Hinweis:',
													message:
														'Der Zahlbetrag wird in Kürze im Rechnungslauf eingezogen. Jahresgebühr sowie Aktivierungsgebühr und Versandkosten werden in der Regel separat abgebucht. Sie werden vor dem Einzug nochmals informiert.',
												},
											]}
										/>
									)}
								</>
							),
						}}
					/>
				</span>
			</>
		),
	};
};
